import { ModelApi } from "@/utils/useEngineModel/ModelApi"

export class ModelSandboxFacade extends ModelApi {
  clear() {
    // Free the memory allocated in the sandbox - note this doesn't affect peak memory of the Wasm module.
    this.api?.loadModelFromYaml("")
  }
}
